import { Navigate, Outlet } from "react-router-dom";
import { useIsLawyer } from "@/shared/hooks/useIsLawyer";
import CircularProgress from "@/shared/components/CircularProgress";
import FullscreenLayout from "@/pages/layouts/FullScreenLayout";
import { LAWYER_ROUTES } from "@/shared/constants/paths";

/**
 * Wrapper for onboarding routes
 * Redirects lawyers to their dashboard (lawyers should not access onboarding)
 */
export function OnboardingRouteWrapper() {
  const { isLawyer, isLoading } = useIsLawyer();

  if (isLoading) {
    return (
      <FullscreenLayout>
        <CircularProgress />
      </FullscreenLayout>
    );
  }

  if (isLawyer) {
    return <Navigate to={LAWYER_ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
}
